import React from "react";
import { connect } from "react-redux";
import { modal } from "@mc/mc-legacy";
import CustomPageLayout from "./CustomPageLayout";
import AdminMenu from "../administrace/lists/components/AdminMenu";
import modularForm from "../administrace/forms/PodepisovaniForm";
import PodepisovaniList from "../administrace/lists/components/PodepisovaniList";
import PeceteniList from "../administrace/lists/components/PeceteniList";
/**
 * Stránka administrace, zobrazující menu po levé straně a obsah konkrétní stránky vpravo.
 */

class ProstredkyPage extends React.Component {


  render() {
    return (
      <CustomPageLayout header headerButton={false} searchField={false} title="Prostředky" menu={<AdminMenu />}>
        <PodepisovaniList />
        <PeceteniList></PeceteniList>
      </CustomPageLayout>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps)(ProstredkyPage);
